import React from "react";
import { Input, Form } from "reactstrap";
import DropDown from "../../containers/DropDown/DropDown";
import PropTypes from "prop-types";

import styles from "./FormGetItemByKey.module.scss";

const FormGetItemByKey = ({
  type = "",
  itemKey,
  setItemKey,
  getItemToEdit,
}) => {
  //Refactor to stupid component
  return (
    <div className={styles.formContainer}>
      <h6>Do you want to edit an existing {type}?</h6>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          type && itemKey && getItemToEdit({ type, key: itemKey });
        }}
        className={styles.form}
      >

        <Input
          className={styles.inputEditSpot}
          placeholder={`Find ${type} by key`}
          onChange={(e) => setItemKey(e.target.value)}
          value={itemKey}
        />
        <Input
          disabled={!itemKey}
          className={styles.submit}
          type="submit"
          value="Find"
        />
      </Form>
    </div>
  );
};

export default FormGetItemByKey;
